import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function LocalAreaContent() {
  return <section data-section-id="183633" id="terms-overview" className="w-full bg-background text-foreground dark radiating-pattern">
      <Separator className="w-full bg-secondary/30" />
      
      <div className="container mx-auto px-4 py-16 md:py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
            
            <h2 className="mb-8 text-center font-sans text-4xl font-extrabold uppercase tracking-tighter text-foreground md:text-5xl lg:text-7xl">
              Terms of Service
            </h2>
            
            <div className="space-y-6 font-sans text-lg font-medium leading-relaxed text-foreground/90 md:text-xl">
              <p>
                By accessing and using ThinkLocalPro services, you agree to be bound by the following terms and conditions. These guidelines are designed to ensure a transparent, professional, and mutually beneficial partnership as we work together to scale your local business presence through our innovative digital solutions.
              </p>
              
              <p>
                We maintain rigorous standards for our automated systems and consultative services. Our commitment to excellence means we provide clear expectations regarding service delivery, data privacy, and intellectual property rights. For a detailed breakdown of our operational policies and compliance standards, please review our <Link to="/AboutPage" className="text-primary underline decoration-primary/30 underline-offset-4 transition-colors hover:decoration-primary">governance and ethics</Link> documentation.
              </p>
              
              <p>
                Your continued use of our platform signifies your acceptance of these terms. We periodically update these policies to reflect changes in the digital landscape and regulatory requirements, ensuring that our community remains a secure, reliable, and high-performance environment for sustainable business growth.
              </p>
            </div>

            <div className="mt-10 flex justify-center">
              <Button asChild variant="outline" size="lg" className="rounded-full border-primary bg-primary/10 px-8 text-primary hover:bg-primary hover:text-primary-foreground">
                <Link to="/AboutPage">
                  Review Full Policy
                </Link>
              </Button>
            </div>

          </div>
        </div>
      </div>

      <Separator className="w-full bg-secondary/30" />
    </section>;
}